function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32",
  role: "img",
  "aria-hidden": "true"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "currentColor",
  strokeMiterlimit: "10"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.837 8.058a1.166 1.166 0 112.333 0M22.522 19.764v-5.428a6.573 6.573 0 00-6.519-6.594h0a6.573 6.573 0 00-6.518 6.594v5.428"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.77 22.405H8.237a.233.233 0 01-.206-.336l1.373-2.484h13.194l1.373 2.484a.233.233 0 01-.2.336zM18.405 22.707a2.402 2.402 0 01-4.803 0"
})));